// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subscription, ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// NGRX
// Service
import { SubheaderService } from '../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import { BanThanhPhamService } from '../ban-thanh-pham-service/ban-thanh-pham.service';
//Models
import { BanThanhPhamModel, FileImportHH } from '../ban-thanh-pham-model/ban-thanh-pham.model';
import { ListImageModel } from '../ban-thanh-pham-model/ban-thanh-pham.model';
import { DungChungService } from '../../dung-chung/__services/dung-chung.service';
import { FunctionPublic } from './../../dung-chung/__function/common_function';
import { ContentComponent } from 'app/views/pages/components/content-component/content-component.component';
import { ProductStatusText } from '../../../../../shared/constants/product-status.constant';
import { ProductStatus } from '../../../../../shared/enums/product-status.enum';
@Component({
	selector: 'kt-ban-thanh-pham-edit',
	templateUrl: './ban-thanh-pham-edit.component.html',
	styleUrls: ['../ban-thanh-pham.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BanThanhPhamEditComponent implements OnInit, OnDestroy {
	// Public properties
	@ViewChild('fileUpload', { static: true }) fileUpload;
	BanThanhPham: BanThanhPhamModel;
	BanThanhPhamForm: FormGroup;
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	fixedPoint = 2;
	isZoomSize: boolean = false;
	flagFileImport: FileImportHH = new FileImportHH();
	flagFileDownload: any;

	listId_NhomHH: any[] = [];
	selectId_NhomHH: string = '0';
	listDVT1: any[] = [];
	selectDVT1: string = '0';
	selectDVT2: string = '0';
	selectDVT3: string = '0';
	listBoPhanKiemTra: any[] = [];
	selectBoPhanKiemTra: string = '0';
	selectBoPhanGiamSat: string = '0';
	idLoaiHH = -1;
	tmpDVT1:any;
	listDongSanPham: any[] = [];

	IsValueRd: string = '';
	LinkAvatar: string = '';
	urlsDisplay = [];
	urlsSave = [];
	item: any;

	imageDaiDien: any;
	imgvlDaiDien: any;
	picDaiDien: ListImageModel[] = []

	imagedata: any;
	imgvl: any;

	tongFileChon: number = 0;

	private componentSubscriptions: Subscription;


	//list kho
	listKho: any[] = [];
	select_Kho: string[] = [];
	filtered_Kho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Kho_FilterCtrl: string = '';
	haveElement_Kho: boolean = false;
  isLoading: boolean = false;
  statusText = ProductStatusText;
	constructor(
		public dialogRef: MatDialogRef<BanThanhPhamEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private BanThanhPhamFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private banthanhphamsService: BanThanhPhamService,
		private DungChungService: DungChungService,
		private changeDetect: ChangeDetectorRef
	) { dialogRef.disableClose = true; }
	/**
	 * On init
	 */
	ngOnInit() {

		this.viewLoading = false;
		this.BanThanhPham = this.data.data;
		this.idLoaiHH = this.data.idLoaiHH;
		this.tmpDVT1 = this.BanThanhPham.DVT1;
		this.ListId_NhomHH(this.idLoaiHH);
		this.ListDVT1();
		this.ListBoPhanKiemTra();
		this.loadListKho();
		this.ListDongSanPham();
		this.imagedata = {
			RowID: "",
			Title: "",
			Description: "",
			Required: false,
			Files: []
		}
		this.imageDaiDien = {
			RowID: "",
			Title: "",
			Description: "",
			Required: false,
			Files: []
		}
		if (this.BanThanhPham.Id_HH > 0) {
			if (this.BanThanhPham.listLinkImage.length > 0) {
				for (let i = 0; i < this.BanThanhPham.listLinkImage.length; i++) {
					let a = {
						strBase64: "",
						filename: "",
						extension: "",
						Type: 1,
						type: "image/png",
						src: this.BanThanhPham.domain + this.BanThanhPham.listLinkImage[i].src,
						IsAdd: false,
						IsDel: false
					};
					this.imagedata.Files.push(a)
				}
			}
			if (this.BanThanhPham.HinhDaiDien != null && this.BanThanhPham.HinhDaiDien != '') {

				let a = {
					strBase64: "",
					filename: "",
					extension: "",
					Type: 1,
					type: "image/png",
					src: this.BanThanhPham.domain + this.BanThanhPham.HinhDaiDien,
					IsAdd: false,
					IsDel: false
				};
				this.imageDaiDien.Files.push(a)
				let tmpElement = new ListImageModel();
				tmpElement.clear();
				tmpElement.src = this.BanThanhPham.domain + this.BanThanhPham.HinhDaiDien;
				this.picDaiDien.push(tmpElement);
			}
		}

		this.createForm();
		this.BanThanhPhamForm.get("DVTThongKeTon").valueChanges.subscribe(
			(value) => {
				this.BanThanhPhamForm.controls["DVT2"].clearValidators();
				this.BanThanhPhamForm.controls['DVT2'].updateValueAndValidity();
				this.BanThanhPhamForm.controls["DVT3"].clearValidators();
				this.BanThanhPhamForm.controls['DVT3'].updateValueAndValidity();	
				if(value == "2"){
					this.BanThanhPhamForm.controls["DVT2"].setValidators(Validators.required);
					this.BanThanhPhamForm.controls['DVT2'].updateValueAndValidity();
				}
				else if(value == "3"){
					this.BanThanhPhamForm.controls["DVT3"].setValidators(Validators.required);
					this.BanThanhPhamForm.controls['DVT3'].updateValueAndValidity();
				}
				
			}
		);
		this.banthanhphamsService.data_import.subscribe(res => {
			if (res != null && res != undefined) {
				for (let i = 0; i < res.length; i++) {
					this.flagFileImport = new FileImportHH();
					this.flagFileImport.clear();
					this.flagFileImport.filename = res[i].fileName;
					this.flagFileImport.extension = res[i].extension;
					this.flagFileImport.base64 = res[i].base64;
				}
			}
		});
	}
	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	/**
	 * Create form
	 */
	createForm() {
		this.BanThanhPhamForm = this.BanThanhPhamFB.group({
			maHH: [(this.BanThanhPham.MaHH == null) ? '' : this.BanThanhPham.MaHH, Validators.required],
			tenHH: [(this.BanThanhPham.TenHH == null || this.BanThanhPham.TenHH == '') ? '' : this.BanThanhPham.TenHH, Validators.required],
			ghiChu: [(this.BanThanhPham.GhiChu == null) ? '' : this.BanThanhPham.GhiChu],
			ThoiHanSuDung: [(this.BanThanhPham.ThoiHanSuDung == null) ? 0 : this.BanThanhPham.ThoiHanSuDung, Validators.required],
			phanTramThueVAT: [(this.BanThanhPham.PhanTramThueVAT == null) ? 0 : this.BanThanhPham.PhanTramThueVAT],
			tonKhoToiThieu: [(this.BanThanhPham.TonKhoToiThieu == null || this.BanThanhPham.TonKhoToiThieu == '') ? '0.00' :
				this.f_currency(this.formatNumber(this.BanThanhPham.TonKhoToiThieu))
			],
			dieuKienBaoQuan: [(this.BanThanhPham.DieuKienBaoQuan == null) ? '' : this.BanThanhPham.DieuKienBaoQuan],
			quyDoiDVT2: [(this.BanThanhPham.QuyDoiDVT2 == null || this.BanThanhPham.QuyDoiDVT2 == '') ? '0,00000' : this.f_dynamic(this.BanThanhPham.QuyDoiDVT2)],
			quyDoiDVT3: [(this.BanThanhPham.QuyDoiDVT3 == null || this.BanThanhPham.QuyDoiDVT3 == '') ? '0,00000' : this.f_dynamic(this.BanThanhPham.QuyDoiDVT3)],
			CanPhieuKt: [this.BanThanhPham.CanPhieuKt
			],
			imageDaiDienControl: [this.imageDaiDien.Files],
			imageControl: [this.imagedata.Files],
			QuyCachDongGoi: [(this.BanThanhPham.QuyCachDongGoi == null || this.BanThanhPham.QuyCachDongGoi == '') ? '' : this.BanThanhPham.QuyCachDongGoi],
			DungSaiChoPhepNhap: [(this.BanThanhPham.DungSaiChoPhepNhap == null || this.BanThanhPham.DungSaiChoPhepNhap == '') ? '' : this.f_currency(this.formatNumber(this.BanThanhPham.DungSaiChoPhepNhap))],
			KhoMacDinh: [(this.BanThanhPham.KhoMacDinh == null || this.BanThanhPham.KhoMacDinh == '') ? '' : this.BanThanhPham.KhoMacDinh.toString()],
			DVT1: [(this.BanThanhPham.DVT1 == null || this.BanThanhPham.DVT1 == 0) ? '' :
				this.BanThanhPham.DVT1.toString(), Validators.required
			],
			DVT2: [(this.BanThanhPham.DVT2 == null || this.BanThanhPham.DVT2 == 0) ? '' :
				this.BanThanhPham.DVT2.toString()
			],
			DVT3: [(this.BanThanhPham.DVT3 == null || this.BanThanhPham.DVT3 == 0) ? '' :
				this.BanThanhPham.DVT3.toString()
			],
			DVTThongKeTon: [(this.BanThanhPham.DVTThongKeTon == null || this.BanThanhPham.DVTThongKeTon == 0) ? 1 : this.BanThanhPham.DVTThongKeTon.toString()],

			idLoaiHH: [(this.BanThanhPham.Id_NhomHH == null || this.BanThanhPham.Id_NhomHH == 0) ? '' :
				this.BanThanhPham.Id_NhomHH.toString(), Validators.required
			],
			FileName: [(this.BanThanhPham.TenFileGoc == null) ? '' : this.BanThanhPham.TenFileGoc],
			DongSanPham: [(this.BanThanhPham.DongSanPham == null || this.BanThanhPham.DongSanPham == 0) ? '' :
				this.BanThanhPham.DongSanPham.toString()],
			BCSX_WarningRange: [(this.BanThanhPham.BCSX_WarningRange == null || this.BanThanhPham.BCSX_WarningRange == '') ? '' : this.f_currency(this.formatNumber(this.BanThanhPham.BCSX_WarningRange))],
      STATUS: [(this.BanThanhPham.Status == null ? ProductStatus.Active : this.BanThanhPham.Status.toString()), Validators.required],
		});
		//this.BanThanhPhamForm.controls['DVT1'].disable()
		if (this.BanThanhPham.Id_HH > 0) {
			this.selectId_NhomHH = '' + this.BanThanhPham.Id_NhomHH;
			this.selectDVT1 = '' + this.BanThanhPham.DVT1;
			this.selectDVT2 = '' + this.BanThanhPham.DVT2;
			this.selectDVT3 = '' + this.BanThanhPham.DVT3;
			this.selectBoPhanKiemTra = '' + this.BanThanhPham.BoPhanKiemTra;
			this.selectBoPhanGiamSat = '' + this.BanThanhPham.BoPhanGiamSat;
		}

		// Dynamically switch the required validator for the field: 'quyDoiDVT2' based on the value of the fields 'DVT2'
		this.switchFieldRequire('DVT2', 'quyDoiDVT2');
		// Dynamically switch the required validator for the field: 'quyDoiDVT3' based on the value of the fields 'DVT3'
		this.switchFieldRequire('DVT3', 'quyDoiDVT3');
		
		this.changeDetectorRefs.detectChanges();
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
		if (this.BanThanhPham.Id_HH == 0) {
			return 'Thêm mới bán thành phẩm';
		}
		return `Chỉnh sửa bán thành phẩm - ${this.BanThanhPham.TenHH} `;
	}
	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.BanThanhPhamForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}
	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSubmit(type: boolean) {
    this.isLoading = true;
		this.hasFormErrors = false;
		const controls = this.BanThanhPhamForm.controls;
		/** check form */
		if (this.BanThanhPhamForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
      this.isLoading = false;
			return;
		}
		


		// tslint:disable-next-line:prefer-const
		let editedBanThanhPham = this.prepareBanThanhPhams();
		if (this.BanThanhPham.Id_HH > 0) {
			this.updateBanThanhPham(editedBanThanhPham)
			return;
		}
		this.addBanThanhPham(editedBanThanhPham, type);
	}
	/**
	 * Returns object for saving
	 */
	prepareBanThanhPhams(): BanThanhPhamModel {

		const controls = this.BanThanhPhamForm.controls;
		const _BanThanhPham = new BanThanhPhamModel();
		_BanThanhPham.clear();
		_BanThanhPham.Id_NhomHH = controls['idLoaiHH'].value;
		_BanThanhPham.DVT1 = controls['DVT1'].value;
		_BanThanhPham.DVT2 = controls['DVT2'].value;
		_BanThanhPham.DVT3 = controls['DVT3'].value;
		_BanThanhPham.BoPhanKiemTra = +this.selectBoPhanKiemTra;
		_BanThanhPham.BoPhanGiamSat = +this.selectBoPhanGiamSat;
		_BanThanhPham.MaHH = controls['maHH'].value;
		_BanThanhPham.TenHH = controls['tenHH'].value;
		_BanThanhPham.GhiChu = controls['ghiChu'].value;
		_BanThanhPham.TonKhoToiThieu = controls['tonKhoToiThieu'].value.replace(/,/g, "");
		_BanThanhPham.DieuKienBaoQuan = controls['dieuKienBaoQuan'].value;
		_BanThanhPham.QuyDoiDVT2 = controls['quyDoiDVT2'].value ? this.f_number(controls['quyDoiDVT2'].value) : '';
		_BanThanhPham.QuyDoiDVT3 = controls['quyDoiDVT3'].value ? this.f_number(controls['quyDoiDVT3'].value) : '';
		_BanThanhPham.DVTThongKeTon = 1;
		_BanThanhPham.CanPhieuKt = controls['CanPhieuKt'].value;
		_BanThanhPham.ThoiHanSuDung = controls['ThoiHanSuDung'].value;
		_BanThanhPham.PhanTramThueVAT = controls['phanTramThueVAT'].value;
		_BanThanhPham.QuyCachDongGoi = controls['QuyCachDongGoi'].value;
		_BanThanhPham.DungSaiChoPhepNhap = controls['DungSaiChoPhepNhap'].value;
		_BanThanhPham.KhoMacDinh = controls['KhoMacDinh'].value == '' ? '0' : controls['KhoMacDinh'].value;
		_BanThanhPham.Id_LHH = this.idLoaiHH.toString();
		_BanThanhPham.File_TieuChuan = this.BanThanhPham.File_TieuChuan;
		_BanThanhPham.FileImport = this.flagFileImport;
		_BanThanhPham.DongSanPham = controls['DongSanPham'].value ? +controls['DongSanPham'].value : null;
		this.imgvl = controls['imageControl'].value;
		_BanThanhPham.listLinkImage = [];
    _BanThanhPham.Status = Number(controls['STATUS'].value);

		this.imgvlDaiDien = controls['imageDaiDienControl'].value;

		_BanThanhPham.BCSX_WarningRange = controls['BCSX_WarningRange'].value;

		if (this.imgvl.length > 0) {
			for (let i = 0; i < this.imgvl.length; i++) {
				const md = new ListImageModel();
				md.strBase64 = this.imgvl[i].strBase64;
				md.filename = this.imgvl[i].filename;
				md.src = this.imgvl[i].src;
				md.IsAdd = this.imgvl[i].IsAdd;
				md.IsDel = this.imgvl[i].IsDel;
				md.IsImagePresent = false;
				_BanThanhPham.listLinkImage.push(md);
			}
		}

		if (this.imgvlDaiDien.length > 0) {
			for (let i = 0; i < this.imgvlDaiDien.length; i++) {
				const md = new ListImageModel();
				md.strBase64 = this.imgvlDaiDien[i].strBase64;
				md.filename = this.imgvlDaiDien[i].filename;
				md.src = this.imgvlDaiDien[i].src;
				md.IsAdd = this.imgvlDaiDien[i].IsAdd;
				md.IsDel = this.imgvlDaiDien[i].IsDel;
				md.IsImagePresent = true;
				_BanThanhPham.listLinkImage.push(md);
			}
		}

		//gán lại giá trị id
		if (this.BanThanhPham.Id_HH > 0) {
			_BanThanhPham.Id_HH = this.BanThanhPham.Id_HH;
		}
		return _BanThanhPham;
	}
	/**
	 * Add item
	 *
	 * @param _BanThanhPham: BanThanhPhamModel
	 * @param withBack: boolean
	 */
	addBanThanhPham(_BanThanhPham: BanThanhPhamModel, withBack: boolean = false) {
		this.banthanhphamsService.createBanThanhPham(_BanThanhPham).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.status == 1) {
          this.isChange = true;
          const message = `Bán thành phẩm mới đã được thêm.`;
          this.layoutUtilsService.showInfo(message);
          this.BanThanhPhamForm.reset();

          this.BanThanhPham.clear();
          this.BanThanhPham.DVT1 = this.tmpDVT1;
          this.createForm();

          this.selectBoPhanKiemTra = '';
          this.selectBoPhanGiamSat = '';

          this.imageDaiDien.Files = [];
          this.imagedata.Files = [];
          this.changeDetectView();

          if (withBack)
            this.dialogRef.close({isChange: this.isChange});
        }
        else {
          this.layoutUtilsService.showErorr(res.error.message);
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.layoutUtilsService.showErorr("Có lỗi xảy ra khi thêm bán thành phẩm");
      }
		});
	}
	/**
	 * Update item
	 *
	 * @param _BanThanhPham: BanThanhPhamsModel
	 * @param withBack: boolean
	 */
	updateBanThanhPham(_BanThanhPham: BanThanhPhamModel, withBack: boolean = false) {
		this.banthanhphamsService.updateBanThanhPham(_BanThanhPham).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.status == 1) {
          this.isChange = true;
          const message = `Bán thành phẩm đã được cập nhật`;
          this.layoutUtilsService.showInfo(message);
          this.dialogRef.close({isChange: this.isChange});
        }
        else {
          this.layoutUtilsService.showErorr(res.error.message);
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.layoutUtilsService.showErorr("Có lỗi xảy ra khi cập nhật bán thành phẩm");
      }
		});
	}
	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	closeDialog() {
		this.dialogRef.close(this.isChange);
	}
	ListId_NhomHH(idLoaiHH: any) {
		this.banthanhphamsService.listId_NhomHH(idLoaiHH).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_NhomHH = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ListDVT1() {
		this.banthanhphamsService.listDVT1().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDVT1 = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ListBoPhanKiemTra() {
		this.DungChungService.listPhongBanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listBoPhanKiemTra = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ValidateChangeNumberEvent(event: any, isEvent: boolean = true) {

		var count = 0;

		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == '.') {
					count += 1;
				}
			}
		}
		else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == '.') {
					count += 1;
				}
			}
		}

		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	changeValueOfForm(controlName: string, event: any) {
		if (this.ValidateChangeNumberEvent(event)) {
			let tmpValue = this.BanThanhPhamForm.controls[controlName].value.replace(/,/g, "");
			this.BanThanhPhamForm.controls[controlName].setValue(
				this.f_currency(this.formatNumber(tmpValue))
			);
		}
		else {
			this.BanThanhPhamForm.controls[controlName].setValue(event.target.value);
		}

	}
	f_convertDateTime(date: string) {
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert = year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return a.getFullYear() + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + ("0" + (a.getDate())).slice(-2);
	}
	resizeDialog() {
		if (!this.isZoomSize) {
			this.dialogRef.updateSize('100vw', '100vh');
			this.isZoomSize = true;
		}
		else if (this.isZoomSize) {
			this.dialogRef.updateSize('900px', 'auto');
			this.isZoomSize = false;
		}
	}
	showCachTaoMa() {
		// const _description: string = 'Đây là cách tạo mã cho bán thành phẩm';
		// this.layoutUtilsService.showInfo(_description);

		const dialogRef = this.dialog.open(ContentComponent);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) { return; }
		});
	}
	loadListKho() {
		this.DungChungService.listKho().subscribe(res => {
			if (res && res.status == 1) {
				this.listKho = res.data;
				this.filtered_Kho.next(this.listKho.slice());
				this.changeDetectView();
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		})
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	//#region Kiểm tra định dạng số lượng
	keyUpInputKhoiLuong(event) {
		FunctionPublic.cvKeyUp(event);
	}

	clearSelectKho(event: any) {
		this.BanThanhPhamForm.controls["KhoMacDinh"].setValue('');
		event.stopPropagation();
	}
	filterListKho() {

		if (!this.listKho) {
			return;
		}
		// get the search keyword
		let search = this.Kho_FilterCtrl;
		if (!search) {
			this.filtered_Kho.next(this.listKho.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_Kho.next(
			this.listKho.filter(ts =>
				(ts.MaKho + ' - ' + ts.TenKho).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	selectFile() {
		let el: HTMLElement = this.fileUpload.nativeElement as HTMLElement;
		el.click();
	}
	FileSelected(evt: any) {
		this.BanThanhPham.File_TieuChuan = 0;
		if (evt.target.files && evt.target.files.length) {

			let fileNameList = [];
			for (let i = 0; i < evt.target.files.length; i++) {
				let file = evt.target.files[i];
				this.flagFileDownload = file;
				let fileName = file.name;
				fileNameList.push(fileName);
			}
			let listFileNameStr = fileNameList[0];
			for (var i = 1; i < fileNameList.length; i++) {
				listFileNameStr += ', ' + fileNameList[i];
			}
			this.BanThanhPhamForm.controls["FileName"].setValue(listFileNameStr);

			let el: any = this.fileUpload.nativeElement;
			var service = this.banthanhphamsService;
			var useBase64: boolean = true;
			let tmpDataArray: any = [];

			for (var idx = 0; idx < el.files.length; idx++) {
				var extension = el.files[idx].name.split('.').pop();
				var fileName = el.files[idx].name.substring(0, el.files[idx].name.indexOf(extension) - 1);

				let reader = new FileReader();
				reader.readAsDataURL(el.files[idx]);
				reader.onload = function () {
					let base64Str = reader.result as String;
					var metaIdx = base64Str.indexOf(';base64,');

					base64Str = base64Str.substr(metaIdx + 8);
					var data = {
						fileName: fileName,
						base64: base64Str,
						extension: extension
					};

					tmpDataArray.push(data);
					service.data_import.next(tmpDataArray);
				};
			}
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
	}

	checkNumber() {
		if (this.BanThanhPhamForm.controls["phanTramThueVAT"].value < 0)
			this.BanThanhPhamForm.controls["phanTramThueVAT"].setValue(0);
		if (this.BanThanhPhamForm.controls["phanTramThueVAT"].value > 100)
			this.BanThanhPhamForm.controls["phanTramThueVAT"].setValue(100);
		this.changeDetectView();
	}

	ListDongSanPham() {
		this.banthanhphamsService.listDongSanPham().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDongSanPham = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	changeValueFormFourPoint(controlName: string, event: any) {
		let tmpValue = this.BanThanhPhamForm.controls[controlName].value.replace(/,/g, "");
		this.BanThanhPhamForm.controls[controlName].setValue(FunctionPublic.fmFourPoint(tmpValue, event));
	}

	f_dynamic(item: any = "0.00000", dynamic = 5){
		return FunctionPublic.F_NUMBER_DYNAMIC(item, dynamic);
	}

	changeInputOfForm(controlName: string, event: any, min: number = 0, formGroup) {
		const VALUE_EMPTY = "";
		const MIN_VALUE = min;
		const REGEX_COMMA = /,/g;
		const VALUE_DEFAULT = 0.00000;
		var controls = formGroup.controls;
		var valueControl = controls[controlName].value;
		// .. Giá trị trống thì lấy giá trị min
		if (valueControl == VALUE_EMPTY) controls[controlName].setValue(this.f_number(MIN_VALUE));
		// .. Giá trị không xác thực gán lại 0.0
		if (isNaN(valueControl)) valueControl = VALUE_DEFAULT;
		// .. Giá trị nhỏ hơn min thì = min
		if (Number(valueControl) < min) valueControl = MIN_VALUE;
		// .. Valid mới set giá trị
		if (!controls[controlName].invalid) controls[controlName].setValue(this.f_number(valueControl));
		// .. Giá trị "," thì gán về min
		if (valueControl.toString().indexOf(REGEX_COMMA) == 0 && valueControl.length == 1) valueControl = MIN_VALUE;
		controls[controlName].setValue(this.f_number(valueControl));
	}
	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, 5);
	}

	// Dynamically switch the required validator based on the value of another field
	switchFieldRequire(controlName: string, fieldRequire: string) {
		const form = this.BanThanhPhamForm.controls;

		// Check require if the controlName field has a value
		const required = form[controlName].value != '';

		// Set the validators for the fieldRequire control based on the value of controlName
		form[fieldRequire].setValidators(
			required ? Validators.compose([Validators.required, this.minValidator(0.00001)]) : null
		);

		// Update the validity status of the fieldRequire control
		form[fieldRequire].updateValueAndValidity();
	}

	// Custom validator function for minimum value
	minValidator(minValue: number) {
		return (control: AbstractControl): ValidationErrors | null => {
			// Extract the value from the form control and convert it to a number
			const value = this.f_number(control.value ? control.value : 0);

			// Check if the value is less than the minimum value
			if (value !== null && value !== undefined && value < minValue) {
				// If the value is less than the minimum value, return a validation error object
				return { min: true, actualValue: value, minValue: minValue };
			}

			// If the value is greater than or equal to the minimum value, return null (no validation error)
			return null;
		};
	}
}
